import { AI } from "../apis/ws_api";
import { unprocessAIRandomness, unprocessedAIProportion } from "../utils";
import { AISelection } from "./AISelection";

export function Lobby(props: {
    players: string[];
    ais: AI[];
    addAI: (x: AI) => void;
    deleteAI: (i: number) => void;
}) {
    const players = props.players.map((x, i) => {
        return <li key={i}>{x}</li>;
    });

    const ais = props.ais.map((x, i) => {
        return (
            <li key={i} className="flex-container">
                <span>
                    Proportion: {unprocessedAIProportion(x.proportion)} /
                    Randomness: {unprocessAIRandomness(x.randomness)}
                </span>
                <button
                    onClick={() => {
                        props.deleteAI(i);
                    }}
                >
                    Delete
                </button>
            </li>
        );
    });

    return (
        <div className="lobby">
            <div className="layer-list">
                Players: <ol>{players}</ol>
            </div>
            <div className="layer-list">
                AIs: <ol>{ais}</ol>
            </div>
            <details className="ai-details">
                <summary>Add AI</summary>
                {<AISelection addAI={props.addAI} />}
            </details>
        </div>
    );
}
